//angular
import {
  computed,
  Injectable,
  signal,
  WritableSignal
} from '@angular/core';

//local
import { Right } from '../_interfaces/right';
import {
  AAAAccessResponse,
  AAARights,
  UserService,
  LIBRARY,
  CATALOG,
  SPACEBOT,
  VIEW,
  EDIT,
  ADD,
  CONFIGURE,
  DELETE
} from './user.service';
import { config } from '@fortawesome/fontawesome-svg-core';

@Injectable({
  providedIn: 'root'
})

/*
In deploying the new release to prod there is some discrepancy with the rights - namely, a lot of rights
don't have URIs. This is a temporary fix using the get /v2/user/categories endpoint to scan all rights for
library, catalog and spacebot. I fully anticipate we replace this in the next couple of days when the graph
data is updated, I'm just not quite sure how to do that yet
*/
export class UserPermissionsService {
  public rights: WritableSignal<Right[]> = signal<Right[]>([]);

  public canConfigureCatalog = computed(() => {
    if (this.userAccess() != null) return this.userAccess().rights[CATALOG][CONFIGURE]();
    let r = this.rights().find(i => i.id == '28832' && i.isActive && !i.isDeleted);
    return r !== undefined;
  });

  public canViewCatalog = computed(() => {
    if (this.canConfigureCatalog()) return true;
    if (this.userAccess() != null) return this.userAccess().rights[CATALOG][VIEW]();
    let r = this.rights().find(i => i.id == '24768' && i.isActive && !i.isDeleted);
    return r !== undefined;
  });

  public canViewLibrary = computed(() => {
    if (this.canEditLibrary() || this.canConfigureLibrary() || this.canDeleteLibrary()) return true;
    if (this.userAccess() != null) return this.userAccess().rights[LIBRARY][VIEW]();
    let r = this.rights().find(i => i.id == '16480' && i.isActive && !i.isDeleted);
    return r !== undefined;
  });

  public canAddLibrary = computed(() => {
    if (this.userAccess() != null) return this.userAccess().rights[LIBRARY][ADD]();
    let r = this.rights().find(i => i.id == '20712' && i.isActive && !i.isDeleted);
    return r !== undefined;
  });

  public canEditLibrary = computed(() => {
    if (this.userAccess() != null) return this.userAccess().rights[LIBRARY][EDIT]();
    let r = this.rights().find(i => i.id == '20712' && i.isActive && !i.isDeleted);
    return r !== undefined;
  });

  public canDeleteLibrary = computed(() => {
    if (this.userAccess() != null) return this.userAccess().rights[LIBRARY][DELETE]();
    let r = this.rights().find(i => i.id == '16632' && i.isActive && !i.isDeleted);
    return r !== undefined;
  });

  public canConfigureLibrary = computed(() => {
    if (this.userAccess() != null) return this.userAccess().rights[LIBRARY][CONFIGURE]();
    let r = this.rights().find(i => i.id == '16632' && i.isActive && !i.isDeleted);
    return r !== undefined;
  });

  public canViewSpacebot = computed(() => {
    if (this.userAccess() != null) return this.userAccess().rights[SPACEBOT][VIEW]();
    let r = this.rights().find(i => i.id == '32960' && i.isActive && !i.isDeleted);
    return r !== undefined;
  });

  private userAccess: WritableSignal<AAARights | null>;
  constructor(
    private userService: UserService
  ) {
    this.userAccess = signal(new AAARights());
    this.userService.getRights().subscribe((rights) => {
      this.rights.set(rights);
    });
    this.userService.getUserCategoryAccess().subscribe((access) => {
      this.userAccess().scan(access);
//      this.userAccess.set(rights);
    });
  }
}

